import 'jquery'

export default function tabsChange () {
  $(document).on("change.zf.tabs", function(e) {
    window.dispatchEvent(new Event('resize'))
  })
}
